import InstagramIconDarkMode from "cms/images/InstagramIcon-dark-mode.svg";
import InstagramIconLightMode from "cms/images/InstagramIcon-light-mode.svg";
import LinkedInIconDarkMode from "cms/images/LinkedInIcon-dark-mode.svg";
import LinkedInIconLightMode from "cms/images/LinkedInIcon-light-mode.svg";
import TikTokIconDarkMode from "cms/images/TikTokIcon-dark-mode.svg";
import TikTokIconLightMode from "cms/images/TikTokIcon-light-mode.svg";
import TwitterIconDarkMode from "cms/images/TwitterIcon-dark-mode.svg";
import TwitterIconLightMode from "cms/images/TwitterIcon-light-mode.svg";
import VerifiedIcon from "cms/images/VerifiedIcon.svg";
import YoutubeIconDarkMode from "cms/images/YouTubeIcon-dark-mode.svg";
import YoutubeIconLightMode from "cms/images/YouTubeIcon-light-mode.svg";
import React, { useState } from "react";
import { useTheme } from "styled-components";
import OptimizedImage from "../OptimizedImage";
import RichText from "../RichText";
import Text from "../Text";

export interface SocialProofCardProps {
  quote: Queries.Maybe<Queries.SanityQuoteItem>;
}

import {
  Icon,
  IconContainer,
  Illustration,
  NameAndVerifiedContainer,
  Quote,
  SocialProofContainer,
  SocialProofContent,
  UserInfo,
  VerifiedTagIcon,
} from "./SocialProofCard.styles";

const SocialProofCard: React.FC<SocialProofCardProps> = ({ quote }) => {
  const [isQuoteHovered, setIsQuoteHovered] = useState(false);
  const theme = useTheme();
  const handleMouseEnterForQuote = () => {
    setIsQuoteHovered(true);
  };

  const handleMouseLeaveForQuote = () => {
    setIsQuoteHovered(false);
  };

  return (
    <SocialProofContainer
      href={quote?.url || "/"}
      rel="noopener noreferrer nofollow"
      target="_blank"
      onMouseEnter={handleMouseEnterForQuote}
      onMouseLeave={handleMouseLeaveForQuote}
    >
      <SocialProofContent>
        {quote?.image && (
          <Illustration>
            <OptimizedImage image={quote.image} alt={quote.imageAlt} />
          </Illustration>
        )}
        <UserInfo>
          <NameAndVerifiedContainer>
            <Text variant="B3" as="p">
              {quote?.name}
            </Text>
            {quote?.verifiedTag === true && (
              <VerifiedTagIcon src={VerifiedIcon} />
            )}
          </NameAndVerifiedContainer>
          <Text variant="B4" as="p" color="#AEAEAE">
            {quote?.socialsHandle}
          </Text>
        </UserInfo>
        <IconContainer>
          {quote?.variant === "instagram" && (
            <Icon
              src={
                theme.mode === "light"
                  ? InstagramIconLightMode
                  : InstagramIconDarkMode
              }
              $isHovered={isQuoteHovered}
            />
          )}
          {quote?.variant === "linkedin" && (
            <Icon
              src={
                theme.mode === "light"
                  ? LinkedInIconLightMode
                  : LinkedInIconDarkMode
              }
              $isHovered={isQuoteHovered}
            />
          )}
          {quote?.variant === "tiktok" && (
            <Icon
              src={
                theme.mode === "light"
                  ? TikTokIconLightMode
                  : TikTokIconDarkMode
              }
              $isHovered={isQuoteHovered}
            />
          )}
          {quote?.variant === "twitter" && (
            <Icon
              src={
                theme.mode === "light"
                  ? TwitterIconLightMode
                  : TwitterIconDarkMode
              }
              $isHovered={isQuoteHovered}
            />
          )}
          {quote?.variant === "youtube" && (
            <Icon
              src={
                theme.mode === "light"
                  ? YoutubeIconLightMode
                  : YoutubeIconDarkMode
              }
              $isHovered={isQuoteHovered}
            />
          )}
        </IconContainer>
      </SocialProofContent>
      {quote?._rawQuote && (
        <Quote>
          <RichText text={quote?._rawQuote} variant="B2" />
        </Quote>
      )}
    </SocialProofContainer>
  );
};

export default SocialProofCard;
